export default {
  audit: {
    alocationSituation: 'Allocation Situation',
    sendSituation: 'Send Situation',
    alocation: 'Allocation',
    stores: 'Stores',
    auditHistory: 'Allocation History',
    productCode: 'Product Code',
    skuCode: 'SKU Code',
    sizeCode: 'Size Code',
    storeOrders: 'Store Orders',
    quantityAlocated: 'Allocated Quantity',
    quantityMissing: 'Missing Quantity',
    quantityDemanded: 'Demanded Quantity',
    color: 'Assortment',
    productName: 'Product Name',
    storeCode: 'Store Code',
    totalPieces: 'Total Pieces',
    message: 'Message',
    information: 'Information',
    emissionDate: 'Emission Date',
    integrationDate: 'Integration Date',
    store: 'Store',
    order: 'Order',
    notIntegrated: 'Order not integrated to ERP',
  },
  estoqueCentral: {
    title: 'Store Stock Query',
    description: 'This tool allows you to check the stock available in all stores of the Tata Martello network. Browse through products, select colors and sizes to view real-time availability. Stocks are automatically updated with each access to ensure accurate information.',
    tableTitle: 'Products in Stock',
    searchPlaceholder: 'Search by name or reference code...',
    verCores: 'View Colors',
    errorLoading: 'Error loading central stock data',
    noDataAvailable: 'No products found',
    pagination: {
      itemsPerPage: 'Items per page',
      showingRecords: 'Showing {start}-{end} of {total} records',
      noResults: 'No results found',
      page: 'Page {current} of {total}',
      goToFirst: 'First page',
      goToPrevious: 'Previous page',
      goToNext: 'Next page',
      goToLast: 'Last page',
    },
    fields: {
      nomeReferencia: 'Reference Name',
      codigoReferencia: 'Reference Code',
      categoria: 'Category',
      marca: 'Brand',
      acoes: 'Actions',
      codigo: 'Code',
      produto: 'Product',
      quantidade: 'Quantity',
      preco: 'Price',
      status: 'Status',
    },
  },
};
